<template>
  <div class="main-contain">
    <div class="main-contain-left">
      <div class="intro-title">
        <el-image :src="courseImg" class="title-icon" />
        <div class="title-text"><span>互动问答</span></div>
      </div>
      <div class="qa-header">
        <div class="qa-actions">
          <!-- <el-select v-model="queryParams.belong_type" placeholder="全部类型" size="small" class="type-select"
            @change="getQAList">
            <el-option label="全部类型" :value="0"></el-option>
            <el-option label="课程问题" :value="1"></el-option>
            <el-option label="实验问题" :value="2"></el-option>
          </el-select> -->
          <el-button type="primary" class="publish-btn" @click="add_interactive">发布问题</el-button>
        </div>
      </div>

      <div class="qa-filters">
        <div class="filter-item" v-for="filter in filterList" :key="filter.type"
          :class="{ active: queryParams.type === filter.type }" @click="changebt(filter.type)">
          <span>{{ filter.label }}</span>
          <!-- <span class="filter-count">({{ filterCounts[filter.type] || 0 }})</span> -->
        </div>
      </div>

      <div class="qa-list">
        <div class="qa-card" v-for="(item, index) in qadata" :key="index">
          <div class="qa-card-main">

            <div class="qa-content">
              <div class="qa-title" @click="openreplypanel(item)">
                <div class="qa-icon">
                </div>
                <span class="title-text">{{ item.title }}</span>
                <div class="qa-tags">
                  <span v-if="item.is_top === 1" class="qa-tag tag-top">置顶</span>
                  <span v-if="item.is_teacher_join === 1" class="qa-tag tag-teacher">教师参与</span>
                  <span v-if="Number(item.has_publish) === 0" class="qa-tag tag-pending">待审核</span>
                </div>
              </div>
              <div class="qa-desc">
                <div class="qa-icon">
                </div>
                <span class="desc-text" v-html="htmlDecode(item.content)"></span>
              </div>
              <div class="qa-meta">
                <div class="qa-author">
                  <div class="qa-icon">
                  </div>
                  <span class="author-name">{{ item.author_name }}</span>
                  <span class="author-dept">{{ item.department || item.college }}</span>
                  <span class="publish-time">{{ item.created_at }}</span>
                </div>
                <div class="qa-stats" v-if="Number(item.has_publish) === 1">
                  <div class="stat-item">
                    <img class="stat-icon" :src="view_d" />
                    <span class="stat-num">{{ item.view_count }}</span>
                  </div>
                  <div class="stat-item" @click="setlikebt(item.id, item.like_status)">
                    <img class="stat-icon" :src="item.like_status === 1 ? like_c : like_d" />
                    <span class="stat-num">{{ item.like_count }}</span>
                  </div>
                  <div class="stat-item" @click="openreplypanel(item)">
                    <img class="stat-icon" :src="review_d" />
                    <span class="stat-num">{{ item.reply_count }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 分页 -->
      <div class="elpagination" v-if="total > 0">
        <div class="elpagination-title">共{{ total }}条</div>
        <el-pagination background layout="prev, pager, next" :total="total" :page-size="10"
          :current-page="queryParams.page" @current-change="pageChange"></el-pagination>
      </div>

      <Customdialog ref="customdialog" :type="'max'" width="50%" title="互动问答回复" :showclose="true"
        @isDialogClose="closereplypanel">
        <div slot="dialogbody" class="dialogbody">
          <Interactiveanswerreply ref="replypanel" v-if="isFlag" @childReset="initNewData"></Interactiveanswerreply>
        </div>
      </Customdialog>
      <Customdialog ref="customdialogqa" :type="'max'" width="50%" title="发布问题" :showclose="true"
        @isDialogClose="closepostpanel">
        <div slot="dialogbody" class="dialogbody">
          <PostQuestion ref="postquestion" v-if="ispostFlag" :course_semester_sn="courseKey"></PostQuestion>
        </div>
      </Customdialog>
    </div>
  </div>
</template>
<script>
import { autoImgCorrection } from "@/utils/index";
import { getQaList, setQaLike } from "@/api/qa";
import dayjs from "dayjs";
import Interactiveanswerreply from "./interactiveanswerreply";
import PostQuestion from "./postQuestion.vue";
import pagTable from "@/components/Pagination/pagTable";
import Customdialog from "@/components/customdialog.vue";
const cityOptions = ["仅教师参与", "回复最多"];
export default {
  name: "virtualexperiment",
  components: {
    pagTable,
    Customdialog,
    Interactiveanswerreply,
    PostQuestion,
  },
  data() {
    return {
      courseKey: "",
      radio: 0,
      testimage: require("@/assets/test.png"),
      view_d: require("@/assets/course/UIout/QA/QA_ico_preview.png"),
      like_c: require("@/assets/course/UIout/QA/QA_ico_like.png"),
      like_d: require("@/assets/course/UIout/QA/QA_ico_like.png"),
      review_d: require("@/assets/course/UIout/QA/QA_ico_question.png"),
      avater1: require("@/assets/course/UIout/QA/QA_ico_name.png"),
      courseImg: require("@/assets/course/UIout/courseintro/courseintro_decor_01.png"),
      checkAll: false,
      checkedCities: [],
      cities: cityOptions,
      isIndeterminate: true,
      qadata: [],
      total: 0,
      queryParams: {
        keyword: "",
        belong_type: 0,
        type: 0,
        related_type: 1,
        related_id: "",
        per_page: 10, // 每页条数
        page: 1,
      },
      filterList: [
        { label: "全部", type: 0 },
        { label: "仅教师参与", type: 1 },
        { label: "仅我发布的", type: 2 },
        { label: "仅我回答的", type: 3 },
      ],
      filterCounts: {
        0: 0,
        1: 0,
        2: 0,
        3: 0,
      },
      isFlag: false,
      ispostFlag: false,
      infoData: {},
    };
  },
  created() { },
  methods: {
    // 初始化数据
    initdata(obj, courseKey) {
      console.log("问答讨论", obj, courseKey);
      if (courseKey) {
        this.infoData = obj;
        this.courseKey = courseKey;
        this.getFilterCounts();
        this.getQAList();
      }
    },
    initNewData(data) {
      if (data) {
        this.initdata(this.infoData, this.courseKey);
      }
    },
    // 获取问答列表
    async getQAList() {
      this.qadata = [];
      this.queryParams.course_semester_sn = this.courseKey;
      let params = this.queryParams;
      await getQaList(params)
        .then((response) => {
          if (response && response.code === 0) {
            this.total = response.data.total;
            let newData = response.data.data;
            if (newData && newData.length > 0) {
              newData.forEach((item) => {
                item.created_at = dayjs
                  .unix(item.created_at)
                  .format("YYYY-MM-DD HH:mm:ss");
              });
              this.qadata = newData;
            }
          }
        })
        .catch((error) => {
          //console.log(error)
        });
    },
    pageChange(val) {
      this.queryParams.page = val;
      this.getQAList(this.queryParams);
    },
    // 打开对话框
    openreplypanel(item) {
      this.isFlag = true;
      this.$refs.customdialog.dialogopenbt();
      this.$nextTick(() => {
        this.$refs.replypanel.initdata(item);
      });
    },
    // 关闭对话框
    closereplypanel() {
      this.isFlag = false;
    },
    closepostpanel() {
      this.ispostFlag = false;
    },
    toreply(item) {
      let obj = JSON.stringify(item);
      this.$router.push({
        path: "/home/virtualsimulationexperiment/interactiveanswerreply",
        query: {
          id: this.vr_id,
          item: encodeURIComponent(obj),
        },
      });
    },
    changebt(value) {
      this.queryParams.type = parseInt(value);
      this.queryParams.page = 1;
      this.getQAList();
    },
    // 获取各筛选条件数量
    async getFilterCounts() {
      const requests = this.filterList.map((filter) => {
        const params = {
          ...this.queryParams,
          type: filter.type,
          page: 1,
          per_page: 1,
        };
        return getQaList(params)
          .then((res) => {
            if (res && res.code === 0) {
              return { type: filter.type, total: res.data.total || 0 };
            }
            return { type: filter.type, total: 0 };
          })
          .catch(() => ({ type: filter.type, total: 0 }));
      });
      const results = await Promise.all(requests);
      results.forEach((r) => {
        this.$set(this.filterCounts, r.type, r.total);
      });
    },
    setlikebt(id, like_status) {
      let params = { id: id };
      setQaLike(params)
        .then((response) => {
          this.queryParams.type = 0;
          if (like_status === 1) {
            this.$message.success("取消点赞成功");
          } else {
            this.$message.success("点赞成功");
          }
          setTimeout(() => {
            this.getQAList();
          }, 1500);
        })
        .catch((error) => {
          //console.log(error)
        });
    },

    add_interactive() {
      // 跳转
      // this.$router.push({
      //   path: "/home/personalcenter/courseinteractiveqa",
      //   query: { course_semester_sn: this.courseKey },
      // });
      // course_semester_sn: this.courseKey
      // this.queryParams.course_semester_sn = this.courseKey;
      this.ispostFlag = true;
      this.$refs.customdialogqa.dialogopenbt();
      // this.$nextTick(() => {
      //   this.$refs.postquestion.initdata(item);
      // });
    },
    htmlDecode(text) {
      const that = this
      if (text) {
        let textContent = text.replace(/&lt;/g, "<").replace(/&gt;/g, ">").replace(/&amp;/g, "&").replace(/&quot;/g, '"').replace(/&apos;/g, "'").replace(/\\/g, '');
        // let img = []
        textContent.replace(/<img.+?>/ig, function (matchImg, captureImg) {
          let resImgSrc = matchImg.replace("../uploads", that.$api.baseUrl + "/uploads").replace(/\\/g, '') // 自定义变量接收图片
          text = textContent.replace(matchImg, resImgSrc)
        })
        textContent.replace(/<video(([\s\S])*?)<\/video>/gi, function (matchImg, captureImg) {
          let resVideoSrc = matchImg.replace("../uploads", that.$api.baseUrl + "/uploads").replace(/\\/g, '') // 自定义变量接收图片
          text = textContent.replace(matchImg, resVideoSrc)
        })
        textContent.replace(/<p>([^<]*?)<\/p>/gi, function (matchImg) {
          let resPSrc = matchImg.replace(/<p>([^<]*?)<\/p>/gi, '$1').replace(/\\/g, '') // 自定义变量接收图片
          text = textContent.replace(matchImg, resPSrc)
        })
      }
      return text
    },
  },
};
</script>
<style lang="scss" scoped>
.main-contain {
  background: #FFFFFF;
  border-radius: 12px;

  .main-contain-left {
    margin-top: 10px;
    width: 100%;
    position: relative;
    min-height: 400px;
    background: url(~@/assets/course/UIout/QA/material_decor_QA.png) no-repeat;
    background-position: right bottom;
    box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
    padding: 30px;
    box-sizing: border-box;

    .intro-title {
      display: flex;
      align-items: center;
      gap: 10px;

      .title-icon {
        position: absolute;
      }

      .title-text {
        font-weight: 500;
        font-size: 18px;
        color: #333333;
        text-align: left;
        font-style: normal;
        text-transform: none;
        position: relative;
        left: 5%;
      }

      i {
        margin-right: 8px;
        color: #7b5cff;
        font-size: 20px;
      }
    }

    .qa-header {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 20px;


      .qa-actions {
        display: flex;
        align-items: center;
        gap: 12px;

        .type-select {
          width: 120px;

          ::v-deep .el-input__inner {
            border-radius: 20px;
          }
        }

        .publish-btn {
          background: #6a5af9;
          border-color: #6a5af9;
          border-radius: 20px;
          padding: 9px 22px;

          &:hover {
            background: #7b6cfa;
            border-color: #7b6cfa;
          }
        }
      }
    }

    .qa-filters {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 20px;

      .filter-item {
        padding: 8px 18px;
        background: #ffffff;
        border: 1px solid #e0e0e0;
        border-radius: 20px;
        font-size: 14px;
        color: #666666;
        cursor: pointer;
        user-select: none;
        transition: all 0.3s;

        &:hover {
          color: #6a5af9;
          border-color: #6a5af9;
        }

        &.active {
          background: rgba(106, 90, 249, 0.1);
          border-color: #6a5af9;
          color: #6a5af9;
        }

        .filter-count {
          margin-left: 4px;
          font-size: 13px;
        }
      }
    }

    .qa-list {
      .qa-card {
        margin-bottom: 16px;
        padding: 20px;
        background: rgba(248, 247, 255, 0.8);
        border: 1px solid #edeaff;
        border-radius: 16px;
        transition: all 0.3s;

        &:hover {
          box-shadow: 0 4px 16px rgba(106, 90, 249, 0.08);
        }

        .qa-card-main {
          display: flex;
          gap: 16px;

          .qa-icon {
            width: 30px;
            height: 30px;
            flex-shrink: 0;
            display: flex;
            align-items: center;
            justify-content: center;
            background: url(~@/assets/course/UIout/QA/QA_ico_question.png) no-repeat;
            background-size: 100% 100%;

            // i {
            //   color: #ffffff;
            //   font-size: 22px;
            // }
          }

          .qa-content {
            flex: 1;
            min-width: 0;

            .qa-title {
              display: flex;
              align-items: center;
              flex-wrap: wrap;
              gap: 10px;
              cursor: pointer;
              margin-bottom: 15px;

              .title-text {
                font-weight: 500;
                font-size: 18px;
                color: #333333;
                text-align: left;
                font-style: normal;
                text-transform: none;
              }

              &:hover .title-text {
                color: #6a5af9;
              }

              .qa-tags {
                display: flex;
                gap: 8px;

                .qa-tag {
                  padding: 2px 8px;
                  font-size: 12px;
                  border-radius: 4px;

                  &.tag-top {
                    color: #0fbf7f;
                    background: rgba(15, 191, 127, 0.1);
                    border: 1px solid #0fbf7f;
                  }

                  &.tag-teacher {
                    color: #6a5af9;
                    background: rgba(106, 90, 249, 0.1);
                    border: 1px solid #6a5af9;
                  }

                  &.tag-pending {
                    color: #f13218;
                    background: rgba(241, 50, 24, 0.1);
                    border: 1px solid #f13218;
                  }
                }
              }
            }

            .qa-desc {
              // margin-top: 10px;
              // font-size: 14px;
              // color: #666666;
              // line-height: 1.6;
              // word-break: break-word;
              // word-wrap: break-word;
              // white-space: pre-line;
              // overflow: hidden;
              // text-overflow: ellipsis;
              // display: -webkit-box;
              // -webkit-line-clamp: 2;
              // -webkit-box-orient: vertical;
              display: flex;
              align-items: center;
              gap: 10px;
              margin-bottom: 20px;

              .qa-icon {
                width: 30px;
                height: 30px;
                flex-shrink: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                background: url(~@/assets/course/UIout/QA/QA_ico_answer.png) no-repeat;
                background-size: 100% 100%;
              }

              .desc-text {
                font-weight: 400;
                font-size: 16px;
                color: #555555;
                text-align: left;
                font-style: normal;
                text-transform: none;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 1; // 设置显示的行数
                overflow: hidden;
                text-overflow: ellipsis;
              }
            }

            .qa-meta {
              // margin-top: 16px;
              display: flex;
              justify-content: space-between;
              align-items: center;
              flex-wrap: wrap;
              gap: 12px;

              .qa-author {
                display: flex;
                align-items: center;
                gap: 10px;

                .qa-icon {
                  width: 30px;
                  height: 30px;
                  flex-shrink: 0;
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  background: url(~@/assets/course/UIout/QA/QA_ico_name.png) no-repeat;
                  background-size: 100% 100%;
                }

                .author-name {
                  font-weight: 400;
                  font-size: 14px;
                  color: #AAAAAA;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }

                .author-dept,
                .publish-time {
                  font-weight: 400;
                  font-size: 14px;
                  color: #AAAAAA;
                  text-align: left;
                  font-style: normal;
                  text-transform: none;
                }
              }

              .qa-stats {
                display: flex;
                align-items: center;
                gap: 20px;

                .stat-item {
                  display: flex;
                  align-items: center;
                  gap: 6px;
                  cursor: pointer;

                  .stat-icon {
                    width: 18px;
                    height: 18px;
                  }

                  .stat-num {
                    font-size: 13px;
                    color: #999999;
                  }

                  &:hover .stat-num {
                    color: #6a5af9;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

}

.elpagination {
  margin-top: 40px;
  display: flex;
  justify-content: center;
  padding-right: 20px;
  align-items: center;

  .elpagination-title {
    margin-right: 4px;
  }
}

::v-deep .text img {
  max-width: 100%;
  height: auto;
}

::v-deep .el-dialog {
  background: #FFFFFF;
  box-shadow: 0px 2px 8px 0px rgba(128, 112, 250, 0.1);
  border-radius: 12px 12px 12px 12px;
}

/* 响应式 */
@media screen and (max-width: 768px) {
  .discussion-container {
    padding: 12px;

    .qa-header {
      flex-direction: column;
      align-items: flex-start;
      gap: 12px;

      .qa-title {
        font-size: 16px;

        .qa-count {
          font-size: 13px;
        }
      }

      .qa-type-select {
        width: 100%;
      }

      .publish-btn {
        width: 100%;
      }
    }

    .qa-filter-bar {
      flex-direction: column;
      align-items: flex-start;
      gap: 10px;

      .filter-tags {
        flex-wrap: wrap;
        gap: 8px;

        .filter-item {
          padding: 6px 12px;
          font-size: 13px;
        }
      }
    }

    .qa-list {
      .qa-card {
        padding: 12px;

        .qa-card-main {
          gap: 10px;

          .qa-icon {
            width: 36px;
            height: 36px;

            i {
              font-size: 18px;
            }
          }

          .qa-content {
            .qa-title-row {
              .qa-card-title {
                font-size: 15px;
              }

              .qa-card-tags {
                .qa-tag {
                  font-size: 11px;
                  padding: 1px 6px;
                }
              }
            }

            .qa-desc {
              font-size: 13px;
              line-height: 22px;
            }

            .qa-meta {
              flex-direction: column;
              align-items: flex-start;
              gap: 6px;

              .meta-left {
                .author-name {
                  font-size: 13px;
                }

                .publish-time {
                  font-size: 12px;
                }
              }

              .meta-right {
                gap: 12px;

                .stat-item {
                  .stat-num {
                    font-size: 12px;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .elpagination {
    margin-top: 24px;
    padding-right: 0;
    flex-wrap: wrap;
    gap: 8px;

    .elpagination-title {
      font-size: 13px;
      width: 100%;
      text-align: center;
      margin-right: 0;
      margin-bottom: 4px;
    }

    ::v-deep .el-pagination {

      .btn-prev,
      .btn-next,
      .el-pager li {
        min-width: 30px;
        height: 30px;
        line-height: 30px;
        font-size: 12px;
      }
    }
  }
}

@media screen and (max-width: 480px) {
  .discussion-container {
    padding: 8px;

    .qa-header {
      .qa-title {
        font-size: 15px;
      }
    }

    .qa-filter-bar {
      .filter-tags {
        .filter-item {
          padding: 5px 10px;
          font-size: 12px;
        }
      }
    }

    .qa-list {
      .qa-card {
        padding: 10px;

        .qa-card-main {
          flex-direction: column;

          .qa-icon {
            width: 32px;
            height: 32px;
          }

          .qa-content {
            .qa-title-row {
              .qa-card-title {
                font-size: 14px;
              }
            }

            .qa-desc {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
}
</style>
